import React from 'react';
import { Box, Heading, Text, Center } from '@chakra-ui/react';

const CustomCard = ({ appName, description, onButtonClick, icon, bgColor, textColor, ...props }) => {
  return (
    <Box
      w="221px"  // Set width
      h="156px"  // Increased height for more space
      p={5}
      borderWidth={1}
      borderRadius="xl"
      textAlign="center"
      transition="0.3s"
      boxShadow="lg"
      bg={bgColor}  // Use the passed bgColor
      _hover={{ transform: 'scale(1.05)', boxShadow: 'xl' }}
      onClick={onButtonClick}
      cursor="pointer"
      {...props}
    >
      {/* Center the Icon */}
      {icon && (
        <Center mb={4}>  {/* Use Center to horizontally and vertically align the icon */}
          {icon}
        </Center>
      )}
      
      {/* Application Name */}
      <Heading size="md" mb={2} color={textColor} fontSize="lg">
        {appName}
      </Heading>

      {/* Application Description */}
      <Text color={textColor} fontSize="sm">
        {description}
      </Text>
    </Box>
  );
};

export default CustomCard;
